import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabaseClient';

export interface FraseHero {
  id_frase: string;
  frase: string;
}

const useFrasesHero = () => {
  const [frases, setFrases] = useState<FraseHero[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    supabase
      .from('frases_hero')
      .select('id_frase, frase')
      .eq('activo', true)
      .order('orden')
      .then(({ data, error }) => {
        if (error) setError(error.message);
        else setFrases(data ?? []);
        setLoading(false);
      });
  }, []);

  return { frases, loading, error };
};

export default useFrasesHero;
